module.exports = __webpack_public_path__ + "static/media/first-offers-bg.9db90dd1.webp";